export const SET_ASIDE_MENU = 'GET_ASIDE_MENU'
export const SET_PUBLIC_STATE = 'SET_PUBLIC_STATE'
export const SET_SECOND_DOCUMENT = 'SET_SECOND_DOCUMENT'
export const SET_FIRST_DOCUMENT = 'SET_FIRST_DOCUMENT'
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS'
export const SET_CLONE_DATA = 'SET_CLONE_DATA'
export const SET_IS_GET_CLONE_STATUS = 'SET_IS_GET_CLONE_STATUS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js